<template>
    <div class="v-modal" :class="{'v-modal--visible': show}">
        <div class="v-modal__pane">
            <div class="v-modal__exit" @click="close()">
                <i-cross></i-cross>
            </div>
            <div class="v-modal__content">
                <slot></slot>
            </div>
        </div>
        <div class="v-modal__backdrop" @click="close()">

        </div>
    </div>

</template>

<script>
  import iCross from "./icons/cross"

  export default {
    name: "v-modal",
    components: {
      iCross,
    },
    props: {
      show: { type: Boolean, default: false },
      blocking: { type: Boolean, default: false }
    },
    methods: {
      close() {
        this.$emit("close");
      }
    }
  }
</script>

<style lang="scss">

    //noinspection CssUnknownTarget
    @import '~@/scss/main.scss';

    .v-modal {

        &__exit {
            padding: .5em;
            cursor: pointer;
            width: 2em;
            height: 2em;
            position: absolute;
            top: .5em;
            font-size: 2em;
            right: 1em;

            g {
                fill: $dim-color;
            }

            &:hover {

                g {
                    fill: $pane-contrast;
                }
            }

        }

        &__pane {

            z-index: 20;
            pointer-events: none;
            opacity: 0;
            transition: 0.2s ease all;
            transform: rotateX(0) translateZ(0) scale(0.99) translateX(-50%) translateY(-50%);
            transform-origin: top;
            max-height: 90vh;
            overflow: auto;
            width: 40em;
            max-width: 90vw;
            font-size: .9em;
            box-shadow: 0 2px 15px rgba(0, 0, 0, 0.25);
            color: $dark-color;
            background-color: $pane-color;
            padding: 5em;
            border-radius: 0.25em;
            position: fixed;
            top: 50%;
            left: 50%;
            @include media("<tablet") {
                padding: 4em 3em;
            }

        }
        &__backdrop {
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            pointer-events: none;
            opacity: 0;
            background-color: rgba(6, 23, 15, 0.6);
            z-index: 10;
        }

        &--visible {

            .v-modal {

                &__pane {
                    pointer-events: auto;
                    opacity: 1;
                    transform: rotateX(0) translateZ(0) scale(1) translateX(-50%) translateY(-50%);
                }

                &__backdrop {
                    pointer-events: auto;
                    opacity: 1;

                }
            }
        }

    }


</style>